import { Component } from 'react';
import { connect } from 'react-redux';
import BrandCarouselItem from './brand-carousel-item';
import CarouselRender from './carousel-render';
import BrandBanner from './brand-banner';

import './brand-carousel.css';
import './style.css';

class BrandCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      activeBannerBrandId: 0,
      data: []
    };
  }

  renderItems = () => {
    const { brands } = this.props;
    const { isScrolled } = this.state;

    this.setState({
      data: brands.map((brand, index) => (
        <div
          key={index}
          onMouseEnter={() => {
            this.setState({ activeBannerBrandId: brand.id });
          }}
        >
          <BrandCarouselItem
            key={index}
            image={brand.links.photo}
            id={brand.id}
            name={brand.attributes.name}
            isScrolled={isScrolled}
          />
        </div>
      ))
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.brands !== this.props.brands &&
      Array.isArray(this.props.brands) &&
      !!this.props.brands.length) {
      this.renderItems();
    }
  }

  componentDidMount = () => {
    this.renderItems();
  }

  handleOnClick = () => {
    const { isScrolled } = this.state;

    this.setState({ isScrolled: !isScrolled }, () => {
      this.renderItems();
    });
  }

  render() {
    const { loading, brands } = this.props;
    const { activeBannerBrandId, data } = this.state;
    const brandBanner = +activeBannerBrandId === 0 ? brands[0] : brands.find(brand => (+brand.id === +activeBannerBrandId));
    const isMobileScreen = window.innerWidth <= 768;

    return (
      <div className="brand-carousel-container">
        {!!data.length && (
          <div className="user-inner-container">
            <h2>Our Tobacco Range</h2>
          </div>
        )}
        {brandBanner && !isMobileScreen && <BrandBanner links={brandBanner.links} attributes={brandBanner.attributes} />}
        <CarouselRender loading={loading} data={data} onClick={this.handleOnClick} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.brandsUser.fetching,
  brands: state.brandsUser.brands
});

export default connect(mapStateToProps)(BrandCarousel);
